/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 浏览旗舰店和页面任务
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export default async function (
  browseTaskReq: member.BrowseTaskReq,

  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: boolean;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "post",
    url: `/member/member/growth-task/browse`,
    data: browseTaskReq,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
